import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './AuthPages.css';

export const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const { resetPassword } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    
    if (!email.trim()) {
      setError('Por favor, insira seu email.');
      return;
    }

    setLoading(true);

    try {
      const { error } = await resetPassword(email);
      
      if (error) {
        if (error.message.includes('User not found')) {
          setError('Não encontramos uma conta com este email.');
        } else {
          setError(error.message);
        }
      } else {
        setSuccess(true);
      }
    } catch (err: any) {
      setError('Ocorreu um erro ao enviar o email. Por favor, tente novamente.');
      console.error('Reset password error:', err);
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="auth-page">
        <div className="auth-container success">
          <div className="success-icon">📧</div>
          <h2>Email enviado!</h2>
          <p>
            Enviamos instruções para redefinir sua senha para <strong>{email}</strong>.
            Por favor, verifique sua caixa de entrada.
          </p>
          <p className="text-muted">
            Não recebeu o email? Verifique sua pasta de spam ou tente novamente em alguns minutos.
          </p>
          <div className="auth-footer">
            <Link to="/auth/login" className="auth-button primary">
              Voltar para Login
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-header">
          <h1>🎯 Rifa Tudo</h1>
          <h2>Recuperar senha</h2>
          <p>Digite seu email e enviaremos instruções para redefinir sua senha.</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="seu@email.com"
              required
              autoComplete="email"
              disabled={loading}
            />
          </div>

          {error && (
            <div className="error-message">
              <span>⚠️</span> {error}
            </div>
          )}

          <button 
            type="submit" 
            className="auth-button primary"
            disabled={loading}
          >
            {loading ? 'Enviando...' : 'Enviar email de recuperação'}
          </button>
        </form>

        <div className="auth-footer">
          <p>
            Lembrou da senha?{' '}
            <Link to="/auth/login" className="auth-link">
              Voltar para login
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};